import { useEffect, useState } from "react";
import { BookOpen, FileBarChart2, Flame, Tags } from "lucide-react";

const Q = "?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";
const SLIDES = [
  { src: `https://images.unsplash.com/photo-1568901346375-23c9450c58cd${Q}`, alt: "Hambúrguer artesanal", tag: "Hamburgueria" },
  { src: `https://images.unsplash.com/photo-1513104890138-7c749659a591${Q}`, alt: "Pizza artesanal", tag: "Pizzaria" },
  { src: `https://images.unsplash.com/photo-1578985545062-69928b1d9587${Q}`, alt: "Bolo de confeitaria", tag: "Confeitaria" },
  { src: "/hero/restaurante.jpg", alt: "Prato feito de restaurante", tag: "Restaurante" },
  { src: "/hero/acai.jpg", alt: "Açaí na tigela com frutas", tag: "Açaiteria" },
  { src: "/hero/lanchonete.jpg", alt: "Coxinhas e refrigerante", tag: "Lanchonete" },
];
const SEGMENTS = ["Hamburgueria", "Pizzaria", "Confeitaria", "Restaurante", "Pastelaria", "Lanchonete", "Açaiteria", "Cafeteria", "Marmitaria", "Doceria", "Sorveteria", "Food truck"];
const PROOFS = [[BookOpen, "Ficha técnica com custo real"], [Tags, "Preço certo em cada canal"], [FileBarChart2, "DRE e ponto de equilíbrio"]];

const Logo = ({ light }) => (
  <div className="flex items-center gap-2">
    <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${light ? "bg-primary text-white" : "bg-primary text-primary-foreground"}`}><Flame className="w-5 h-5" /></div>
    <div className="leading-tight"><span className="font-display font-extrabold text-xl">Pedrada</span><p className={`text-[10px] uppercase tracking-widest ${light ? "text-white/60" : "text-muted-foreground"}`}>Gestão financeira para food service</p></div>
  </div>
);

export const AuthShell = ({ title, subtitle, children, footer }) => {
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI((x) => (x + 1) % SLIDES.length), 6000); return () => clearInterval(t); }, []);
  return (
    <div className="min-h-app grid lg:grid-cols-[55fr_45fr]">
      <div className="relative hidden lg:block overflow-hidden grain bg-[#0D0F12]" data-testid="auth-hero">
        {SLIDES.map((s, k) => (
          <img key={s.src} src={s.src} alt={s.alt} loading={k === 0 ? "eager" : "lazy"} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ease-in-out ${k === i ? "opacity-100 hero-zoom" : "opacity-0"}`} />
        ))}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0F12] via-[#0D0F12]/55 to-[#0D0F12]/10" />
        <div className="absolute inset-x-0 top-0 p-10 flex items-center justify-between text-white">
          <Logo light />
          <span key={i} className="rise px-3 py-1 rounded-full text-xs font-semibold bg-white/10 backdrop-blur-md border border-white/15" data-testid="auth-hero-tag">{SLIDES[i].tag}</span>
        </div>
        <div className="absolute bottom-0 inset-x-0 p-10 text-white space-y-6">
          <div className="space-y-3 max-w-xl">
            <h2 className="font-display text-4xl xl:text-5xl font-extrabold leading-[1.05]">Do cardápio ao lucro: saiba o custo real de cada produto e o preço certo em cada canal.</h2>
            <p className="text-white/70 text-base">Para qualquer negócio de alimentação — sem planilha, em linguagem simples.</p>
          </div>
          <div className="flex gap-3 flex-wrap">
            {PROOFS.map(([I, t]) => <span key={t} className="flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/15"><I className="w-3.5 h-3.5 text-primary" />{t}</span>)}
          </div>
          <div className="relative overflow-hidden -mx-10 mask-fade" data-testid="auth-segments">
            <div className="flex gap-2 w-max marquee">
              {[...SEGMENTS, ...SEGMENTS].map((s, k) => <span key={k} className="text-xs px-3 py-1 rounded-full border border-white/15 text-white/70 whitespace-nowrap">{s}</span>)}
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 relative">
        <div className="lg:hidden absolute inset-x-0 top-0 h-40 overflow-hidden" aria-hidden>
          <img src={SLIDES[i].src} alt="" className="w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background" />
        </div>
        <div className="w-full max-w-md rise relative">
          <div className="lg:hidden mb-8"><Logo /></div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-2">{subtitle}</p>}
          <div className="mt-8 space-y-4">{children}</div>
          {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
          <p className="mt-8 text-[11px] text-muted-foreground/70 flex items-center gap-1.5">Acesso individual · pagamento único · seus dados são só seus</p>
        </div>
      </div>
    </div>
  );
};
